// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimExternalReferenceModel {
    static getAttributeTypeMap() {
        return ClaimExternalReferenceModel.attributeTypeMap;
    }
}
ClaimExternalReferenceModel.discriminator = undefined;
ClaimExternalReferenceModel.additionalProperties = false;
ClaimExternalReferenceModel.attributeTypeMap = [
    {
        "name": "externalReferenceTypeId",
        "baseName": "externalReferenceTypeId",
        "type": "number"
    },
    {
        "name": "externalValue",
        "baseName": "externalValue",
        "type": "string"
    },
];
//# sourceMappingURL=claimExternalReferenceModel.js.map